import { render, staticRenderFns } from "./PriceCard.vue?vue&type=template&id=7c189f42&"
import script from "./PriceCard.vue?vue&type=script&lang=js&"
export * from "./PriceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports